export enum TWACorrectionMethod {
    QuebecModel = 0,
    BriefAndScalaModel = 1,
    OSHA_AltLinear = 2,
    MSHASilica = 3
}